import { createBrowserClient } from '@supabase/ssr'

export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}

export function getPublicUrl(bucket: string, fullPath: string): string {
  return createClient().storage.from(bucket).getPublicUrl(fullPath).data
    .publicUrl
}
